import { jsx } from "react/jsx-runtime";
import { Box } from "braid-design-system";
import { useState, useEffect } from "react";
import { progressBarVariant } from "./ProgressBarChart.css.mjs";
const ProgressBarChart = ({
  color,
  backgroundColor = "#EAECF1",
  progress,
  barHeight
}) => {
  const [width, setWidth] = useState(0);
  useEffect(() => {
    const immediateId = setTimeout(() => {
      setWidth(progress);
    }, 0);
    return () => clearTimeout(immediateId);
  }, [progress]);
  return /* @__PURE__ */ jsx(
    Box,
    {
      className: progressBarVariant[barHeight || "xsmall"],
      borderRadius: "full",
      position: "relative",
      width: "full",
      style: {
        backgroundColor
      },
      children: /* @__PURE__ */ jsx(
        Box,
        {
          borderRadius: "full",
          className: progressBarVariant[barHeight || "xsmall"],
          "data-testid": "progress-bar",
          position: "absolute",
          left: 0,
          style: {
            backgroundColor: color,
            width: `${width}%`
          }
        }
      )
    }
  );
};
export {
  ProgressBarChart
};
